import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../../taboola-common-frontend-modules/i18n';
import styles from './CampaignGroupTooltip.module.scss';

const classNameBuilder = classNames.bind(styles);

const StepsComponent = () => {
    return (
        <div className={classNameBuilder('wizard-container')}>
            <div className={classNameBuilder('wizard-steps')}>
                <div className={classNameBuilder('step-container')}>
                    <div className={classNameBuilder('step')}>
                        <span className={classNameBuilder('step-label')}>Account</span>
                    </div>
                </div>
                <div className={classNameBuilder('step-connector')}></div>
                <div className={classNameBuilder('step-container')}>
                    <div className={classNameBuilder('step', 'step-active')}>
                        <span className={classNameBuilder('step-label')}>Campaign group</span>
                    </div>
                </div>
                <div className={classNameBuilder('step-connector')}></div>
                <div className={classNameBuilder('step-container')}>
                    <div className={classNameBuilder('step')}>
                        <span className={classNameBuilder('step-label')}>Campaign</span>
                    </div>
                </div>
                <div className={classNameBuilder('step-connector')}></div>
                <div className={classNameBuilder('step-container')}>
                    <div className={classNameBuilder('step')}>
                        <span className={classNameBuilder('step-label')}>Ads</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const CampaignGroupTooltip = ({ onCreateGroup }) => (
    <div className={styles.tooltipContainer}>
        <div className={classNameBuilder('title-container')}>
            <span className={classNameBuilder('emoji')}>⚡</span>
            <h3 className={classNameBuilder('title')}>
                <FormattedMessage id="app.campaigns.create.button.title" defaultMessage="Introducing campaign groups" />
            </h3>
        </div>
        <div className={classNameBuilder('message-container')}>
            <FormattedMessage
                id="app.campaigns.create.button.message.one"
                defaultMessage="From now on, <b>group your new campaigns</b> that share the same marketing objective, success metrics, and performance expectations into campaign groups.{newline}{newline}Campaign groups allow easier management, budget control at the group level, personalized recommendations, and enhanced reporting."
            />
        </div>
        <StepsComponent />
        <div className={classNameBuilder('message-container')}>
            <FormattedMessage
                id="app.campaigns.create.button.message.two"
                defaultMessage="After creating your first campaign group, we will guide you through creating your campaign"
            />
        </div>
        <button onClick={onCreateGroup} className={classNameBuilder('button')}>
            <FormattedMessage id="app.campaigns.create.button.create" defaultMessage="Create campaign group" />
        </button>
    </div>
);

CampaignGroupTooltip.propTypes = {
    onCreateGroup: PropTypes.func.isRequired,
};
